import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { RouterContext } from '../router.js';
import { NotFound } from '../station/route-states.js';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: NotFound,
});
